import './Apps.css';
import { Link } from 'react-router-dom';
import ParticlesBg from 'particles-bg';
import { appsData } from './appsData';

function Apps() {

  return (
    <div className="apps-page">
      <ParticlesBg type="cobweb" bg={true} color="#00d4ff" num={50} />

      {/* Header */}
      <header className="header">
        <div className="header-content">
          <Link to="/" className="logo">
            <img src="/profile.png" alt="Süleyman Sezer" className="logo-img" />
            <span className="logo-text">Süleyman Sezer</span>
          </Link>
          <nav className="nav">
            <Link to="/" className="nav-link">Ana Sayfa</Link>
            <Link to="/apps" className="cta-button active">Uygulamalar</Link>
          </nav>
        </div>
      </header>

      {/* Apps Section */}
      <section className="apps-content">
        <h1 className="apps-page-title">Geliştirdiğim Appler</h1>

        <div className="apps-grid-full">
          {appsData.map((app, index) => (
            <div
              key={index}
              className="app-card-full"
              onClick={() => app.playStoreUrl && window.open(app.playStoreUrl, '_blank')}
              style={{ cursor: app.playStoreUrl ? 'pointer' : 'default' }}
            >
              <div className="app-image-full" style={{background: `linear-gradient(135deg, ${app.color} 0%, ${app.color}dd 100%)`}}>
                {app.image.startsWith('/') ? (
                  <img src={app.image} alt={app.name} className="app-icon-full" />
                ) : (
                  <div className="app-placeholder-full">{app.image}</div>
                )}
              </div>
              <div className="app-info-full">
                <h3>{app.name}</h3>
                <p>{app.description}</p>
                <div className="app-meta">
                  <span className="app-date">{app.date}</span>
                  {app.downloads && app.rating && (
                    <div className="app-stats-inline">
                      <span className="stat-badge">⬇️ {app.downloads}</span>
                      <span className="stat-badge">⭐ {app.rating}</span>
                    </div>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* Footer */}
      <footer className="footer">
        <div className="footer-content">
          <p className="footer-copyright">© 2024 Süleyman Sezer. Tüm hakları saklıdır.</p>
        </div>
      </footer>
    </div>
  );
}

export default Apps;
